const carRental = {
  carRental: "Rental Mobil", // translated 
  carRentals: "Penyewaan Mobil", // translated 
  pickUpPoint: "Titik Penjemputan", // translated 
  dropOffPoint: "Daerah menurunkan barang atau penumpang", // translated 
  pleaseSelectAPickUpPoint: "Silakan pilih Titik Penjemputan", // translated 
  pickUpDate: "Tanggal Penjemputan", // translated 
  dropOffDate: "Tanggal Pengantaran", // translated 
  pickUp: "Menjemput", // translated 
  dropOff: "Pengantaran", // translated 
  edit: "Sunting", // translated 
  fuelPolicy: "Kebijakan Bahan Bakar", // translated 
  pickUpLocation: "Lokasi penjemputan", // translated 
  mileage: "Jarak tempuh", // translated 
  transmission: "Penularan", // translated 
  airCondition: "Kondisi udara", // translated 
  minimumAge: "Usia Minimum", // translated 
  maximumAge: "Usia Maksimum", // translated 
  providerAddress: "Alamat Penyedia", // translated 
  providerPhone: "Telepon Penyedia", // translated 
  driverInfo: "Info Pengemudi", // translated 
  driversInfo: "Info Pengemudi", // translated 
  differentDropOff: "Pengantaran di lokasi berbeda", // translated 
  maxPassengers: "Penumpang Maks", // translated 
  budget: "Anggaran", // translated 
  provider: "Pemberi", // translated 
  carModel: "Model mobil", // translated 
  numOfDoors: "Jumlah Pintu", // translated 
  fuelType: "Jenis bahan bakar", // translated 
  driverAge: "Usia Pengemudi", // translated 
  enterValidDriversAge: "Silakan masukkan Usia Pengemudi yang valid.", // translated 
  workingHours: "Jam kerja", // translated 
  driverNationality: "Kebangsaan Pengemudi", // translated 
  nationalityIsRequired: "Kebangsaan diperlukan", // translated 
  carRentalRate: "Tarif Sewa Mobil", // translated 
  dueNow: "Karena sekarang", // translated 
  duePickUp: "Karena di Pick-up", // translated 
  toViewOfferPDF:
    "Untuk melihat dokumen PDF yang berisi semua ketentuan sewa dari penawaran ini, silakan", // translated 
  toViewTermsAndCondPDF:
    "Untuk melihat Syarat dan Ketentuan CARNECT yang berlaku, silakan", // translated 
  carRentalsNotFound:
    "Kami tidak dapat menemukan hasil Penyewaan Mobil. Kami mohon maaf atas ketidaknyamanan ini", // translated 
};


export default carRental;
